import React from "react";
import BusinessList from "../Component/BusinessList";
import Navbar from "../Component/Navbar";
import Footer from "../Component/Footer";

const BusinessPage = () => {
  return (
    <div>
      <Navbar />
      <BusinessList />
      <Footer />
    </div>
  );
};

export default BusinessPage;